import { CategoriesList } from '@shared/Features/DesktopLandingGifsSection/CategoriesList/CategoriesList';
import css from './DesktopLandingGifsSection.module.css';
import React, { useEffect, useState } from 'react';
import { DesktopLandingGifItem } from '@modules/Landing/Shared/Interfaces/DesktopLandingGifItem';
import ImageIcon from '@modules/Landing/Shared/Icons/ImageIcon';
import PencilIcon from '@modules/Landing/Shared/Icons/PencilIcon';
import BillIcon from '@modules/Landing/Shared/Icons/BillIcon';
import ClipboardIcon from '@modules/Landing/Shared/Icons/ClipboardIcon';
import DownloadIcon from '@modules/Landing/Shared/Icons/DownloadIcon';

const DesktopLandingGifsSectionCategories: DesktopLandingGifItem[] = [
    {
        icon: <ImageIcon fill={'currentColor'} />,
        name: 'Choose a Template',
        gif: () => import('@assets/Imgs/LandingDesktopGifs/chooseTemplate.gif'),
    },
    {
        icon: (
            <PencilIcon
                stroke={'currentColor'}
                fill={'none'}
                className={css.pencilIcon}
            />
        ),
        name: 'Enter Your Measurements',
        gif: () =>
            import('@assets/Imgs/LandingDesktopGifs/enterYourMeasurements.gif'),
    },
    {
        icon: (
            <BillIcon
                stroke={'currentColor'}
                fill={'none'}
                className={css.billIcon}
            />
        ),
        name: 'Get Your Bill of Materials',
        gif: () =>
            import(
                '@assets/Imgs/LandingDesktopGifs/getYourBillOfMaterials.gif'
            ),
    },
    {
        icon: (
            <ClipboardIcon
                stroke={'currentColor'}
                fill={'none'}
                className={css.clipboardIcon}
            />
        ),
        name: 'Refine Your List',
        gif: () => import('@assets/Imgs/LandingDesktopGifs/refineYourList.gif'),
    },
    {
        icon: <DownloadIcon fill={'currentColor'} />,
        name: 'Download PDF or Buy Products',
        gif: () => import('@assets/Imgs/LandingDesktopGifs/downloadOrBuy.gif'),
    },
];

export const DesktopLandingGifsSection: React.FC = () => {
    const [activeCategoryIndex, setActiveCategoryIndex] =
        React.useState<number>(0);
    const [gifUrls, setGifUrls] = useState<string[]>([]);

    useEffect(() => {
        const loadGifs = async () => {
            const urls = await Promise.all(
                DesktopLandingGifsSectionCategories.map(async category => {
                    const module = await category.gif();
                    return module.default;
                })
            );
            setGifUrls(urls);
        };

        loadGifs();
    }, []);

    return (
        <section className={css.section}>
            <CategoriesList
                items={DesktopLandingGifsSectionCategories}
                activeCategoryIndex={activeCategoryIndex}
                setActiveCategoryIndex={setActiveCategoryIndex}
            />
            {gifUrls[activeCategoryIndex] ? (
                <img
                    src={gifUrls[activeCategoryIndex]}
                    alt={
                        DesktopLandingGifsSectionCategories[activeCategoryIndex]
                            .name
                    }
                    className={css.gif}
                />
            ) : (
                <div className={css.container} />
            )}
        </section>
    );
};
